import axios, { AxiosResponse } from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { IDealer, IPhone, IDealerResponse } from 'safe'
import {
  DealerTypes,
  SET_DEALERS,
  SET_DEALER,
  UPDATE_DEALER,
  DELETE_DEALER,
  ENABLE_DEALER,
  DELETE_DOCUMENT,
  ADD_DOCUMENT,
} from './actionTypes'

const server = process.env.REACT_APP_SERVER_URL

const setDealers = (dealers: IDealerResponse): DealerTypes => ({
  type: SET_DEALERS,
  payload: dealers,
})
const setDealer = (dealer: IDealer): DealerTypes => ({
  type: SET_DEALER,
  payload: dealer,
})
const editDealer = (dealer: IDealer): DealerTypes => ({
  type: UPDATE_DEALER,
  payload: dealer,
})
const deleteDocument = (documentId, providerId): DealerTypes => ({
  type: DELETE_DOCUMENT,
  payload: {
    documentId,
    providerId,
  },
})
const addDocument = (
  providerId,
  document: { id: string; url: string }
): DealerTypes => ({
  type: ADD_DOCUMENT,
  payload: {
    providerId,
    document,
  },
})
const deleteDealer = (dealer: IDealer): DealerTypes => ({
  type: DELETE_DEALER,
  payload: dealer,
})

const enableDealer = (id: string, enable: boolean): DealerTypes => ({
  type: ENABLE_DEALER,
  payload: { id, enable },
})

export const fetchDealers =
  (
    querySearch: string[] = [],
    paginationParams: string[]
  ): ThunkAction<Promise<void>, {}, {}, DealerTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, DealerTypes>): Promise<void> => {
    try {
      const response: AxiosResponse<{
        status: number
        providers: IDealer[]
        numberOfPages: number
      }> = await axios.get(
        `${server}/thirdparty/provider?${[
          ...querySearch,
          ...paginationParams,
        ].join('&')}`
      )
      dispatch(
        setDealers({
          providers: response.data.providers,
          numberOfPages: response.data.numberOfPages,
        })
      )
    } catch (e) {
      throw e
    }
  }

export const createDealer =
  (
    dealer: any,
    hasImage: boolean,
    fd: FormData
  ): ThunkAction<Promise<void>, {}, {}, DealerTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, DealerTypes>): Promise<any> => {
    try {
      // const parsedPhones = dealer.provider.phones.map((phone: IPhone) => ({
      //   ...phone,
      //   id: Number(phone.id),
      // }))
      const response: AxiosResponse<{
        status: number
        provider: IDealer
      }> = await axios.post(`${server}/thirdparty/provider`, dealer)

      if (hasImage) {
        const response2: AxiosResponse<any> = await axios.put(
          `${server}/media/file?idEntity=${response.data.provider.id}&entity=provider`,
          fd
        )
      }
      return response

      // dispatch(setDealer(response.data.provider))
    } catch (e) {
      throw e
    }
  }

export const updateDealer =
  (
    dealer: {
      provider: IDealer
    },
    hasImage: boolean = false,
    fd: FormData = new FormData()
  ): ThunkAction<Promise<void>, {}, {}, DealerTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, DealerTypes>): Promise<void> => {
    // !dealer.provider.phones && (dealer.provider.phones = [])
    try {
      // console.log(JSON.stringify(dealer.provider, null, 2))
      const response: AxiosResponse<{
        status: number
        provider: IDealer
      }> = await axios.patch(`${server}/thirdparty/provider`, { ...dealer })
      dispatch(editDealer(response.data.provider))
      // if (hasImage) {
      //   const response2: AxiosResponse<{
      //     status: number
      //     file: {
      //       id: string
      //       url: string
      //     }
      //   }> = await axios.put(
      //     `${server}/media/file?idEntity=${response.data.provider.id}&entity=provider`,
      //     fd
      //   )
      //   // dispatch(
      //   //   addDocument(response.data.provider.id, {
      //   //     id: response2.data.file.id,
      //   //     url: response2.data.file.url,
      //   //   })
      //   // )
      // }
    } catch (e) {
      throw e
    }
  }

export const removeDealer =
  (dealer: IDealer): ThunkAction<Promise<void>, {}, {}, DealerTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, DealerTypes>): Promise<void> => {
    try {
      await axios.delete(`${server}/thirdparty/provider?id=${dealer.id}`)
      dispatch(deleteDealer(dealer))
    } catch (e) {
      throw e
    }
  }

export const onEnableDealer =
  (
    id: string,
    enable: boolean
  ): ThunkAction<Promise<void>, {}, {}, DealerTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, DealerTypes>): Promise<void> => {
    try {
      await axios.patch(`${server}/thirdparty/provider`, {
        id,
        enable,
      })
      dispatch(enableDealer(id, enable))
    } catch (e) {
      throw e
    }
  }

export const deleteDocumentDealer =
  (id, url, providerId): ThunkAction<Promise<void>, {}, {}, DealerTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, DealerTypes>): Promise<void> => {
    try {
      const response: AxiosResponse<{
        status: number
        updatedProvider: IDealer
      }> = await axios.put(
        `${server}/media/delete-file?idEntity=${id}&entity=provider`,
        {
          originalname: url,
        }
      )
      dispatch(deleteDocument(id, providerId))
    } catch (e) {
      throw e
    }
  }
